import { LegacyDocumentType } from '@prisma/client';
import { upsertFile } from '../../document/createDocument';

export interface createFileForFormDocumentSubmissionParams {
  fileUrl: string;
  fileName: string;
  documentType: LegacyDocumentType;
  corporationId: number;
  formSubmissionId?: string;
  serviceRequestId?: string;
}

/**
 * Creates a file record in the database for a form submission.
 * Called just before submission to obtain a stable fileId
 * that replaces the raw S3 fileUrl in the submission payload.
 */
export async function createFileForFormDocumentSubmission(
  params: createFileForFormDocumentSubmissionParams,
  shareToken: string | undefined
): Promise<{ id: number } | null> {
  return upsertFile(
    {
      fileUrl: params.fileUrl,
      fileName: params.fileName,
      documentType: params.documentType,
      corporationId: params.corporationId,
      formSubmissionId: params.formSubmissionId,
      serviceRequestId: params.serviceRequestId,
    },
    shareToken
  );
}
